import { profileSlice } from './slice';

export * from './state';
export * from './profile';
export * from './license';

const Reducer = profileSlice.reducer;

export { Reducer };
